module.exports = __webpack_public_path__ + "9c41961e03902d9ca2c41d5eae77a912.png";